import request from '@/utils/request'

// 微信用户登陆
export function login(uid) {
  return request({
    url: '/iot/wechatUser/login/' + uid,
    method: 'get'
  })
}

// 微信用户注册
export function register(code) {
  return request({
    url: '/iot/wechatUser/register/' + code,
    method: 'get'
  })
}

// 绑定
export function bind(data) {
  return request({
    url: '/iot/wechatUser/bind',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/wechat.js